export default __webpack_public_path__ + "static/media/powered by xp.d7778593.svg";